var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',[_vm._v("Welcome to the Sensoreal Admin Dashboard.")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }